import * as React from 'react';
import { ReactElement, useEffect, useState } from 'react';
import { Loader } from 'idsk-react-components';
import { useParams } from 'react-router';
import { Breadcrumbs, Message, NotFoundPage } from 'slovlex-idsk-react-components';
import routes from '../../routing/routes';
import Layout from '../Layout';
import PredpisyCudziJazyk from '../../module/PredpisyCudziJazyk/PredpisyCudziJazyk';
import usePredpisyCudziJazykPage from './hook/usePredpisyCudziJazykPage';

const PredpisyCudziJazykPage = (): ReactElement => {
  const { id } = useParams();

  const {
    data,
    status,
  } = usePredpisyCudziJazykPage(id);
  const [displayError, setDisplayError] = useState(true);

  useEffect(() => {
    if (data && data.jazyk) {
      window.parent.postMessage({
        type: 'iframe-to-parent-set-title',
        title: data.jazyk,
      }, '*');
    }
  }, [data]);

  return (
    <Layout>
      <Breadcrumbs
        routeList={[
          {
            to: routes.home.to,
            heading: routes.home.name,
          },
          {
            to: routes.pravnePredpisy.to,
            heading: routes.pravnePredpisy.name,
          },
          {
            to: routes.jazyk.withParams(id || ''),
            heading: data && data.nadpisStrankaSk,
          }]}
      />
      <Loader loading={status.loading}>
        <>
          {status.responseCode && status.responseCode === 404 && (
            <NotFoundPage />
          )}
          {status.responseCode && status.responseCode > 404
          && displayError && (
            <Message
              type="error"
              onClear={() => setDisplayError(false)}
              headingSize="m"
            >
              Z technických príčin nebolo možné vykonať požadovanú akciu. Skúste neskôr.
            </Message>
          )}
          { id && data && (
          <PredpisyCudziJazyk
            id={id}
            totalElements={data?.predpisy['@nodes'].length}
            predpisyCudziJazyk={data}
          />
          )}
        </>
      </Loader>
    </Layout>
  );
};

export default PredpisyCudziJazykPage;
